module.exports = __webpack_public_path__ + "img/category_1.0cf96c64.svg";